import { useEffect } from "react";
import confetti from "canvas-confetti";
import { motion } from "framer-motion";
import { Heart, Coffee } from "lucide-react";
import { Button } from "@/components/ui/button";

const COLORS = ["#F59E0B", "#F43F5E", "#FDE68A", "#FBCFE8", "#A7F3D0", "#BFDBFE"];

const burst = () => {
  const end = Date.now() + 1600;
  const frame = () => {
    confetti({ particleCount: 4, angle: 60, spread: 70, origin: { x: 0, y: 0.7 }, colors: COLORS, zIndex: 9999 });
    confetti({ particleCount: 4, angle: 120, spread: 70, origin: { x: 1, y: 0.7 }, colors: COLORS, zIndex: 9999 });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  confetti({ particleCount: 120, spread: 90, origin: { y: 0.55 }, colors: COLORS, zIndex: 9999 });
  frame();
};

export default function TipThanks({ amountCents, message, onDone, doneLabel = "Back to my notes" }) {
  useEffect(() => { burst(); return () => confetti.reset(); }, []);
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
      className="text-center"
      data-testid="tip-thanks"
    >
      <motion.div
        animate={{ rotate: [0, -8, 8, -4, 0], scale: [1, 1.12, 1] }}
        transition={{ duration: 1.2, delay: 0.2 }}
        className="h-20 w-20 rounded-3xl bg-gradient-to-br from-amber-400 to-rose-500 flex items-center justify-center mx-auto mb-5 shadow-lg"
      >
        <Coffee className="h-10 w-10 text-white" />
      </motion.div>
      <h1 className="font-display font-bold text-3xl mb-2" data-testid="tip-thanks-title">Thank you so much!</h1>
      {amountCents > 0 && (
        <p className="text-stone-600 dark:text-stone-300 mb-1" data-testid="tip-thanks-amount">
          Your <span className="font-semibold text-amber-600 dark:text-amber-400">£{(amountCents / 100).toFixed(2)}</span> tip just made our day.
        </p>
      )}
      <p className="text-sm text-stone-500 dark:text-stone-400 mb-5 inline-flex items-center gap-1">
        It keeps Mango Notes growing <Heart className="h-3.5 w-3.5 fill-rose-500 text-rose-500" />
      </p>
      {message && (
        <p className="italic text-sm text-stone-500 dark:text-stone-400 bg-stone-50 dark:bg-stone-900 rounded-xl p-3 mb-5" data-testid="tip-thanks-message">
          "{message}"
        </p>
      )}
      <div className="flex items-center justify-center gap-2">
        <Button variant="outline" className="rounded-full" onClick={burst} data-testid="tip-thanks-confetti-btn">Celebrate again</Button>
        <Button className="rounded-full" onClick={onDone} data-testid="tip-thanks-done-btn">{doneLabel}</Button>
      </div>
    </motion.div>
  );
}
